import {Component, EventEmitter, Input, Output} from '@angular/core';
import {MatIcon} from '@angular/material/icon';
import {MatIconButton} from '@angular/material/button';
import {MatTooltipModule} from '@angular/material/tooltip';

@Component({
  selector: 'app-selection-action',
  standalone: true,
  imports: [
    MatIcon,
    MatIconButton,
    MatTooltipModule
  ],
  templateUrl: './selection-action.component.html',
  styleUrl: './selection-action.component.scss'
})
export class SelectionActionComponent {

  @Input() icon: string = '';
  private tooltipValue: string = '';

  @Input() set tooltip(value: string | null) {
    this.tooltipValue = value ?? '';
  }

  get tooltip(): string {
    return this.tooltipValue;
  }
  @Input() ariaLabel: string | null = null;
  @Input() disabled: boolean = false;
  @Input() tooltipDisabled: boolean = false;

  @Output() actionTriggered: EventEmitter<void> = new EventEmitter<void>();

  protected triggerAction() {
    if (this.disabled) {
      return;
    }
    this.actionTriggered.emit();
  }
}
